module.exports = __webpack_public_path__ + "img/埃利特-唐利.72ede97e.png";